module.exports = __webpack_public_path__ + "static/media/SaveAway401kSingularK.ee8f5cfa.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyEnrollment/Assets/SaveAway401kSingularK.pdf
// module id = 352
// module chunks = 0